import {Card} from "@material-ui/core";
import {CreateProps} from "react-admin";
import {CustomCreate} from "../../components/CustomCreate";
import {NoteConfigurationForm} from "./NoteConfigurationForm";

export const NoteConfigurationCreate = (props: CreateProps) => (
  <CustomCreate {...props} component={Card}>
    <NoteConfigurationForm />
  </CustomCreate>
);
